export interface FAQItem {
  question: string
  answer: string
  /** Optional source attribution for GEO (e.g. "CRA", "OSFI Guideline B-20") */
  source?: string
  /** Optional anchor id, so a page can link an in-page control at one entry. */
  id?: string
}

export interface FAQPageJsonLd {
  '@context': 'https://schema.org'
  '@type': 'FAQPage'
  mainEntity: {
    '@type': 'Question'
    name: string
    acceptedAnswer: {
      '@type': 'Answer'
      text: string
      citation?: {
        '@type': 'CreativeWork'
        name: string
      }
    }
  }[]
  inLanguage?: string
}

export function buildFAQPageJsonLd(
  items: readonly FAQItem[] | null | undefined,
  inLanguage?: string,
): FAQPageJsonLd | null {
  if (!items || items.length === 0) return null

  const mainEntity = items
    .filter((item) => item.question.trim().length > 0 && item.answer.trim().length > 0)
    .map((item) => ({
      '@type': 'Question' as const,
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer' as const,
        text: item.answer,
        ...(item.source
          ? { citation: { '@type': 'CreativeWork' as const, name: item.source } }
          : {}),
      },
    }))

  if (mainEntity.length === 0) return null

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity,
    ...(inLanguage ? { inLanguage } : {}),
  }
}
